<template>
  <div :class="{'mt-0' : isHomePage}" class="cpj-footer">
    <div
      v-if="!$store.state.loading.previewing"
      class="cpj-footer_menu bg-footerA text-white"
    >
      <div class="container">
        <div class="row footer-row">
          <div class="col-md-8 col-lg-9">
            <div class="row l-flex l-j-between">
              <div
                v-for="item in pageList"
                :key="item.pageTitle"
                class="cpj-nav-list col-3"
              >
                <div class="green-underline">
                  <b>{{ item.pageTitle }}</b>
                </div>

                <div v-for="subItem in item.list" :key="subItem.title">
                  <a
                    :href="subItem.url"
                    :rel="!isSameHost(subItem.url) ? 'noopener noreferrer' : ''"
                    :target="subItem.internal ? '' : '_blank'"
                    class="opacity-white"
                  >
                    {{ subItem.title }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-4 col-lg-3 offset-lg-0 info"
          >
            <div class="row no-gutters">
              <div class="col-md-12 col-lg-12">
                <div>
                  <img src="asset/image/logo/getlinks_grey.svg" alt="">
                  <p class="green-underline">
                          {{ cpLang('footer.logo_desc') }}
                          </p>
                          <p>
                  {{ cpLang('footer.follow_us') }}
                  </p>
                  <div class="snsList">
                    <a :href="sns.fb" target="_blank">
                      <div class="snsItem">
                        <div class="fab fa-facebook-f" />
                      </div>
                    </a>
                    <a :href="sns.ln" target="_blank">
                      <div class="snsItem">
                        <div class="fab fa-linkedin" />
                      </div>
                    </a>
                    <a :href="sns.ig" target="_blank">
                      <div class="snsItem">
                        <div class="fab fa-instagram" />
                      </div>
                    </a>
                    <a :href="sns.yt" target="_blank">
                      <div class="snsItem">
                        <div class="fab fa-youtube" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end only for mobile and 768  -->
    <div class="cpj-footer_copyright bg-footerB">
      <div class="cpj-footer_block">
        <div class="container">
          <div class="row w-100">
            <div class="col-12 col-sm-7 col-lg-8">
              <span>
                {{ cpLang("footer.copyright", { year }) }}
              </span>
            </div>
            <div class="col-12 col-sm-5 col-lg-4">
              <div class="cpj-footer_list">
                <a href="/terms-conditions">
                  <span class="cpj-footer_listItem">
                    {{ cpLang("global.tnc") }}
                  </span>
                </a>
                |
                <a href="/privacy-policy">
                  <span class="cpj-footer_listItem">
                    {{ cpLang("footer.privacy_policy") }}
                  </span>
                </a>
                |
                <a href="/site-map">
                  <span class="cpj-footer_listItem">
                    {{ cpLang("footer.sitemap") }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      isHomePage: false,
      year: new Date().getFullYear(),
      pageList: [
        {
          pageTitle: this.cpLang('global.getlinks'),
          list: [
            {
              title: this.cpLang('footer.about_us'),
              url: 'https://getlinks.co/getlinks'
            },
            {
              title: this.cpLang('footer.contact_us'),
              url: 'https://getlinks.co/contactus'
            }
          ]
        },
        {
          pageTitle: this.cpLang('footer.job_seekers'),
          list: [
            {
              title: this.cpLang('footer.find_a_job'),
              url: 'https://jobs.getlinks.com'
            },
            {
              title: this.cpLang('global.match_me'),
              url: 'https://jobs.getlinks.com/myjob/'
            }
          ]
        },
        {
          pageTitle: this.cpLang('global.employers'),
          list: [
            {
              title: this.cpLang('global.post_a_job'),
              url:
                'https://hr.getlinks.com/'
            },
            {
              title: this.cpLang('global.advertise_with_us'),
              url:
                'https://hr.getlinks.com/?_ga=2.48912678.1217550181.1568010936-409796288.1564375602'
            }
          ]
        },
        {
          pageTitle: this.cpLang('footer.community'),
          list: [
            {
              title: this.cpLang('global.events'),
              url: 'https://getlinks.co/events/'
            },
            {
              title: this.cpLang('homepage.card_title2'),
              url: 'https://humansoftech.getlinks.co/'
            },
            {
              title: this.cpLang('homepage.card_title3'),
              internal: true,
              url: 'blog'
            }
          ]
        }
      ],
      enquiryList: [
        {
          title: this.cpLang('global.job_posting'),
          phone: '+ 852 3619 9600 (M-F, 9am - 6pm) ',
          email: 'info@cpjobs.com'
        },
        {
          title: this.cpLang('global.classified_post'),
          phone: '+ 852 2565 8822 (M-F, 9am - 6pm) ',
          email: 'classified@scmp.com'
        },
        {
          title: this.cpLang('global.jiujik'),
          phone: '+ 852 2565 8811 (M-F, 9am - 6pm) ',
          email: 'jiujik@scmp.com'
        }
      ],
      sns: {
        fb: 'https://www.facebook.com/GetLinksInc',
        ln: 'https://www.linkedin.com/company/getlinks/',
        ig: 'https://www.instagram.com/getlinksinc/',
        yt: 'https://www.youtube.com/channel/UCsQ4fUZyyzoNkBbCLkprkow'
      }
    }
  },
  watch: {
    $route(n) {
      if (n.fullPath === '/') {
        this.isHomePage = true
      } else {
        this.isHomePage = false
      }
    }
  },
  mounted() {
    if (this.$route.fullPath === '/') {
      this.isHomePage = true
    }
  },
  methods: {
    isSameHost(url) {
      return String(url).includes('cpjobs.com')
      // try {
      //   const domain = new URL(url).origin ? new URL(url).origin : ''
      //   console.log(url, domain.endsWith('cpjobs.com'))
      //   return domain.endsWith('cpjobs.com')
      // } catch (err) {
      //   return false
      // }
    }
  }
}
</script>

<style lang="scss">
.footer-row{
  .cpj-nav-list{
    .opacity-white{
      &:hover{
        color: #0EA5BF !important;
      }
      &:visited{
        color: #788796;
      }
    }
  }
}
</style>
